import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {onlyToast} from 'hiya-common/src/App/CustomToaster'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'
import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export enum PageTypeEnum {
  monster = 0,
  rank,
}
export enum ModalTypeEnum {
  openBox = 1,
  getReward,
  rank20,
}
export const urlEnum = {
  1: `${HostMaps.prod.img01}/img/png/id/2369875079`,
  2: `${HostMaps.prod.img01}/img/png/id/4271396`,
  3: `${HostMaps.prod.img01}/img/png/id/8795546649`,
  4: `${HostMaps.prod.img01}/img/png/id/8795546304`,
  5: `${HostMaps.prod.img01}/img/png/id/4273545`,
}
// 打怪兽活动配置 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35761410
export const beat_monster_config = createAsyncThunk(
  'beat_monster_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'monsters' | 'count_down' | 'stage_id' | 'gift_id'
        >
      >
    >(
      '/live/activity/beat_monster_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 打怪兽活动获取奖励 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=35761477
export const beat_monster_get_reward = createAsyncThunk(
  'beat_monster_get_reward',
  async (arg: {stage_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'list' | 'reward_info' | 'reward_type' | 'err_msg'
        >
      >
    >(
      '/live/activity/beat_monster_get_reward',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    const {err_msg = ''} = resp.data.data
    if (err_msg) {
      onlyToast(err_msg)
    }
    return resp.data.data
  }
)
export enum statusEnum {
  notStart = 0,
  open,
  opened,
}
interface monster_info {
  hp: number
  now_hp: number
  box_status: statusEnum
  box_coin: number
}

interface InitialStateType {
  monsters?: Array<monster_info>
  count_down?: number
  stage_id?: number
  gift_id?: number
  // 奖励获取
  list?: Array<ListItemType>
  reward_info?: {
    is_coin: boolean
    url: string
    desc: string
    num: number
  }
  reward_type?: number
  err_msg?: string
}

const initialState: InitialStateType = {}

export const FightMonsterSlice = createSlice({
  name: 'FightMonster',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(beat_monster_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(beat_monster_get_reward.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default FightMonsterSlice.reducer
export const FightMonsterActions = FightMonsterSlice.actions
